<template>
    <template v-if="clickUrl && impressionUrl">
        <div v-if="$props.type === 'desktop-banner' || $props.type === 'mobile-banner'"
             :class="$props.class"
             class="flex justify-center items-center"
        >
            <a :href="clickUrl">
                <img :src="impressionUrl"
                     alt="Advertisement"
                     class="inline-block rounded-lg"
                     height="90"
                     loading="lazy"
                     width="728"
                />
            </a>
        </div>
    </template>
</template>

<script>
import {
    inject,
    onMounted,
    ref,
} from 'vue';

export default {
    props: {
        type: {
            type:     String,
            required: true,
            default:  'desktop-banner',
        },

        class: {
            type:     String,
            required: false,
            default:  '',
        },
    },

    setup(props) {
        let injectKey = {
            'desktop-banner': 'advertisementDesktopBannerIndex',
            'mobile-banner':  'advertisementMobileBannerIndex',
        }[props.type];

        const advertisementIndex = inject(injectKey);
        const assignedIndex = ref(0);

        // Assign this component the next available index
        onMounted(() => {
            assignedIndex.value = advertisementIndex.value;
            advertisementIndex.value += 1;  // Move to the next item for the next instance
        });

        return {
            assignedIndex,
        };
    },

    computed: {
        impressionUrl: function () {
            let advertisements = {
                'desktop-banner': this.$page.props.advertisements.desktopBanner,
                'mobile-banner':  this.$page.props.advertisements.mobileBanner,
            }[this.$props.type];

            if (!advertisements || advertisements.length === 0) {
                return null;
            }

            const index = this.assignedIndex % advertisements.length;

            return advertisements[index]?.impression;
        },

        clickUrl: function () {
            let advertisements = {
                'desktop-banner': this.$page.props.advertisements.desktopBanner,
                'mobile-banner':  this.$page.props.advertisements.mobileBanner,
            }[this.$props.type];

            if (!advertisements || advertisements.length === 0) {
                return null;
            }

            const index = this.assignedIndex % advertisements.length;

            return advertisements[index]?.click;
        },
    },
};
</script>